var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "35px",
    viewBox: "0 0 54 38",
    id: "svg36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs40"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title22"
  }, "Icons/Pinpoint Map Copy 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title22"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Rede-Medica_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-03-06-01_ErroAPIPreco",
    transform: "translate(-845.000000, -1102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MAP",
    transform: "translate(741.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Pinpoint-Map-Copy-28",
    transform: "translate(106.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,28 L26.476431,33.5787722 C25.6993451,34.3637635 24.4330308,34.3700599 23.6481084,33.5929045 C23.6480852,33.5928815 23.648062,33.5928586 23.6481077,33.592766 L18,28 L18,28 L32,28 Z",
    id: "Arrow-Baixo",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Valor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L44,0 C47.3137085,-6.08718376e-16 50,2.6862915 50,6 L50,22.1911333 C50,25.5048418 47.3137085,28.1911333 44,28.1911333 L6,28.1911333 C2.6862915,28.1911333 4.05812251e-16,25.5048418 0,22.1911333 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33,25 L26.4773179,31.5796509 C25.6997259,32.3641408 24.4334079,32.3696467 23.6489707,31.5920015 C23.648953,31.5919839 23.6489352,31.5919663 23.6489703,31.5918955 L17,25 L17,25 L33,25 Z",
    id: "Arrow-Cima",
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMessage);
export default __webpack_public_path__ + "static/media/black_message.cc00e96965a2a29d4a289e5c25254ffc.svg";
export { ForwardRef as ReactComponent };